import * as React from 'react';
import { Table } from '../../common';
import StandardModal from '../../common/modals/StandardModal';
import OnPremWorkflowInstanceState from '../../../models/OnPremWorkflowInstanceState';
import './WorkflowHistoryModal.css';

interface WorkflowHistoryModalProps {
    visible: boolean;
    onClose: () => void;
    workflowInstanceStates: OnPremWorkflowInstanceState[];
}

interface WorkflowHistoryModalState {
    statesOnPage: OnPremWorkflowInstanceState[];
}

export default class WorkflowHistoryModal extends React.Component<WorkflowHistoryModalProps, WorkflowHistoryModalState> {
    constructor(props: WorkflowHistoryModalProps) {
        super(props);
        this.state = {
            statesOnPage: [],
        };
    }

    render() {
        const tableRows = [...this.props.workflowInstanceStates]
            .reverse()
            .map((state) => (
                <Table.Row key={state.onPremWorkflowInstanceId}>
                    <Table.Cell>{state.performedOnDate ? new Date(state.performedOnDate).toLocaleString() : 'N/A'}</Table.Cell>
                    <Table.Cell>
                        {state.action ? state.action.charAt(0).toUpperCase() + state.action.slice(1) : ''}
                    </Table.Cell>
                    <Table.Cell>{state.performedByUser?.displayName}</Table.Cell>
                    <Table.Cell>
                        {state.performedReason ? state.performedReason.charAt(0).toUpperCase() + state.performedReason.slice(1) : ''}
                    </Table.Cell>
                    <Table.Cell>{state.onPremWorkflowState?.name}</Table.Cell>
                </Table.Row>
            ));

        return (
            <StandardModal
                show={this.props.visible}
                onDismiss={this.props.onClose}
                title="Workflow History"
                size="em-c-modal--large"
            >
                <Table>
                    <Table.Head>
                        <Table.Head.Row>
                            <Table.Head.Cell>Date</Table.Head.Cell>
                            <Table.Head.Cell>Action</Table.Head.Cell>
                            <Table.Head.Cell>Performed By</Table.Head.Cell>
                            <Table.Head.Cell>Comment</Table.Head.Cell>
                            <Table.Head.Cell>Send to</Table.Head.Cell>
                        </Table.Head.Row>
                    </Table.Head>
                    <Table.Body>{tableRows}</Table.Body>
                </Table>
            </StandardModal>
        );
    }
}
